import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { PDFExportComponent } from "@progress/kendo-angular-pdf-export";
import { IComplaint } from "app/models/complaint/complaint";
import { IComplaintAction } from "app/models/complaint/complaintAction";
import { IComplaintAssociation } from "app/models/complaint/complaintAssociation";
import { IComplaintInspection } from "app/models/complaint/complaintInspection";
import { IComplaintOwnerTenant } from "app/models/complaint/complaintOwnerTenant";
import { IComplaintReferral } from "app/models/complaint/complaintReferral";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SharedService } from "app/services/core/shared.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-print-complaint',
  templateUrl: './print-complaint.component.html',
  styleUrls: ['./print-complaint.component.scss']
})

export class PrintComplaintComponent implements OnInit {
    public isMobile: boolean = false;
  public complaintId : number = 0;
  public complaintJurisdictions: string = '';
  public complaintEnforcementCategory: string = '';
  public isExportingPdf: boolean = false;
  public expandedInspectionNarratives: { [key: string]: boolean } = {};
  public complaintInspectionDisplayRows: Array<{
    inspectionDate: string | null;
    inspectionType: string;
    scope: string;
    inspectionDetails: string;
    isContinuation: boolean;
    sourceRow: IComplaintInspection;
  }> = [];
    enforcementCategoryOptions = [
        {name:'Pre-renovation Education', value:'prerenovation-education', checked:false},
        {name:'Prohibited Activites', value:'prohibited-activites', checked:false},
        {name:'Containment', value:'containment', checked:false},
        {name:'Cleanup/Verification', value:'cleanup-verification', checked:false},
        {name:'Waste Containment/Disposal', value:'wastecontainment-disposal', checked:false},
        {name:'Documentation/Recordkeeping', value:'documentation-recordkeeping', checked:false}
      ];
      jurisdictionOptions = [
        {name:'CCB', value:'CCB', checked:false},
        {name:'HUD', value:'HUD', checked:false},
        {name:'OSHA', value:'OSHA', checked:false},
        {name:'EPA', value:'EPA', checked:false},
        {name:'DEQ', value:'DEQ', checked:false},
        {name:'OHA', value:'OHA', checked:false},
        {name:'Local', value:'Local', checked:false}
      ]
  public complaint: IComplaint = {
    id: 0,
    complainantName: "",
    complainteeName: "",
    complaintProblem: "",
    complaintNumber: "",
    status: "",
    complaintClosedDate: new Date(),
    complainteeFirstName: "",
    complainteeLastName: "",
    complainteePhone: "",
    complainteeEmail: "",
    complainteeAddress: "",
    complainteeCity: "",
    complainteeState: "",
    complainteeZip: "",
    complainteeEmployer: "",
    complaintDate: undefined as any,
    isAnyonymous: false,
    lastUpdatedBy: "",
    lastUpdated: undefined as any,
    complaintAssociationName: "",
    complaintContractor1: "",
    complaintContractor2: "",
    complaintContractor3: "",
    contractorCCB1: "",
    contractorCCB2: "",
    contractorCCB3: "",
    otherWorker: "",
    complainantAddress: "",
    complainantCity: "",
    complainantState: "",
    complainantZip: "",
    complainantCounty: "",
    complaintInvestigator: "",
    investigatorAssignedDate: "",
    complaintAssociations: [],
    associationTypes: [],
    complaintTargetPhone: "",
    complaintTargetEmail: ""
  };

  public complaintReferrals: IComplaintReferral[] = [];
  public complaintReferralTable = 
  {
    layout:{
      columns:['complaintNumber','fullName','email','agencyTypeName','referralDate','agencyEmail','phoneNumber'],
      container:[
        {displayName:'Complaint #',columnName:'complaintNumber', type:'string', size:'14', previewLimit:'18'},        
        {displayName:'First/Last Name',columnName:'fullName', type:'string', size:'30', previewLimit:'40'},
        {displayName:'Email',columnName:'email', type:'string', size:'24', previewLimit:'35'},        
        {displayName:'Agency Type/Name',columnName:'agencyTypeName', type:'string', size:'42', previewLimit:'60'},
        {displayName:'Referral Date',columnName:'referralDate', type:'string', size:'18'},  
        {displayName:'Agency Email',columnName:'agencyEmail', type:'string', size:'26', previewLimit:'40'},
        {displayName:'Phone',columnName:'phoneNumber', type:'string', size:'18', previewLimit:'20'}
      ],
      data: [] as IComplaintReferral[]      
    }
  };
  public complaintReferralsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public complaintReferralTablePageSize = 5;

  public complaintInspections: IComplaintInspection[] = [];
  public complaintInspectionTable = 
  {
    layout:{
      columns:['inspectionDate','inspectionType','scope','inspectionDetails'],
      container:[
        {displayName:'Date of Inspection',columnName:'inspectionDate', type:'date', size:'20'},        
        {displayName:'Inspection Type',columnName:'inspectionType', type:'string', size:'15', previewLimit:'25'},
        {displayName:'Scope',columnName:'scope', type:'string', size:'12', previewLimit:'25'},
        {displayName:'Inspection Details',columnName:'inspectionDetails', type:'string', size:'58', previewLimit:'120'}                
      ],
      data: [] as IComplaintInspection[]      
    }
  };
  public complaintInspectionDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public complaintInspectionTablePageSize = 5;
  private readonly inspectionDetailsMeasurementWidth = 390;
  private readonly inspectionDetailsMaxChunkHeight = 240;

  public complaintActions: IComplaintAction[] = [];
  public complaintActionTable = 
  {
    layout:{
      columns:['actionDate','actionType'],
      container:[
        {displayName:'Date of Action',columnName:'actionDate', type:'date', size:'20'},        
        {displayName:'Type of Action',columnName:'actionType', type:'string', size:'25'}                
      ],
      data: [] as IComplaintAction[]      
    }
  };
  public complaintActionDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public complaintActionTablePageSize = 5;

  public complaintOwnerTenants: IComplaintOwnerTenant[] = [];
  public complaintOwnerTenantTable = 
  {
    layout:{
      columns:['isOwner','fullName','email','phoneNumber','cellNumber','address','city','state','zip'],
      container:[
        {displayName:'Owner',columnName:'isOwner', type:'boolean', size:'11'},        
        {displayName:'First Last Name',columnName:'fullName', type:'string', size:'35', previewLimit:'40'},
        {displayName:'Email',columnName:'email', type:'string', size:'25', previewLimit:'40'},        
        {displayName:'Phone',columnName:'phoneNumber', type:'string', size:'20', previewLimit:'20'},
        {displayName:'Cell',columnName:'cellNumber', type:'string', size:'20', previewLimit:'20'},
        {displayName:'Address',columnName:'address', type:'string', size:'51', previewLimit:'55'},
        {displayName:'City',columnName:'city', type:'string', size:'29', previewLimit:'30'},        
        {displayName:'State',columnName:'state', type:'string', size:'10', previewLimit:'10'},
        {displayName:'Zip',columnName:'zip', type:'string', size:'9', previewLimit:'10'}
      ],
      data: [] as IComplaintOwnerTenant[]      
    }
  };
  public complaintOwnerTenantDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public complaintOwnerTenantTablePageSize = 5;

  public complaintAssocations: IComplaintAssociation[] = [];
  complaintAssociationTable = {
    icon: 'recent_actors',
    title:'Complaint Assocations',
    layout:{
      columns:['id', 'type', 'name'],
      container:[
        {displayName:'Id',columnName:'id', type:'string', size:'20'},
        {displayName:'Type',columnName:'type', type:'string', size:'25'},
        {displayName:'Name',columnName:'name', type:'string', size:'30'}       
      ],
      data: [] as IComplaintAssociation[]      
    }
  }
  public complaintAssocationDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  public complaintAssocationTablePageSize = 5;

  constructor(public sharedService: SharedService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly complaintService: ComplaintService,
    private readonly toastr: ToastrService,
    public dialogRef: MatDialogRef<PrintComplaintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
        this.breakpointObserver.observe([
            Breakpoints.Handset,
            Breakpoints.Tablet,
            Breakpoints.Small,
          ]).subscribe(result => {
            this.isMobile = result.matches;
          });
    }

    displayLimit(text: any, limit: string | number){
        const characterLimit = parseInt(limit as string, 10);
        let newText = text;
        if (typeof text === 'string' && !isNaN(characterLimit) && text.length > characterLimit){
          newText = newText.substring(0, characterLimit) + "...";
        }    
        return newText;
      }

    getPreviewLimit(cellData: any): number {
      return parseInt((cellData && (cellData.previewLimit || cellData.size)) || '0', 10);
    }

    getInspectionNarrativeKey(row: IComplaintInspection): string {
      if (row && row.id) {
        return row.id.toString();
      }

      return [
        row ? row.inspectionDate : '',
        row ? row.inspectionType : '',
        row ? row.scope : '',
        row ? row.inspectionDetails : ''
      ].join('|');
    }

    isInspectionNarrativeExpanded(row: IComplaintInspection): boolean {
      return !!this.expandedInspectionNarratives[this.getInspectionNarrativeKey(row)];
    }

    canExpandInspectionNarrative(row: IComplaintInspection, cellData: any): boolean {
      const details = row ? (row as any)[cellData.columnName] : null;
      return typeof details === 'string' && details.length > this.getPreviewLimit(cellData);
    }

    getInspectionNarrativeText(row: IComplaintInspection, cellData: any): string {
      const details = row ? (row as any)[cellData.columnName] : '';

      if (this.isInspectionNarrativeExpanded(row)) {
        return details;
      }

      return this.displayLimit(details, this.getPreviewLimit(cellData));
    }

    toggleInspectionNarrative(row: IComplaintInspection): void {
      const key = this.getInspectionNarrativeKey(row);
      this.expandedInspectionNarratives[key] = !this.expandedInspectionNarratives[key];
      this.refreshComplaintInspectionDisplayRows();
    }

    setAllInspectionNarratives(expanded: boolean): void {
      this.complaintInspections.forEach(row => {
        this.expandedInspectionNarratives[this.getInspectionNarrativeKey(row)] = expanded;
      });
      this.refreshComplaintInspectionDisplayRows();
    }

    ngOnInit(): void {
      this.complaint = this.data.selectedComplaint;
      this.complaintId = this.complaint.id;
      if (this.complaintId !== 0){
        this.getComplaintAssociations();
        this.getComplaintReferrals();
        this.getComplaintOwnerTenants();
        this.getComplaintInspections();
        this.getComplaintActions();   
        this.getComplaintJurisdictions();
        this.getComplaintEnforcementCategories();   
      } 
    }

    cancel(): void {
      this.dialogRef.close('cancel');
    }

    async exportToPdf(pdf: PDFExportComponent): Promise<void> {
      const fileName = 'Complaint' + this.complaint.complaintNumber + '.pdf';
      this.refreshComplaintInspectionDisplayRows();
      this.isExportingPdf = true;
      this.changeDetectorRef.detectChanges();
      await this.waitForExportRender();

      try {
        const pdfInstance = pdf as any;
        const group = await pdfInstance.exportElement(pdfInstance.element.nativeElement);
        const dataUri = await pdfInstance.exportGroup(group, pdfInstance.pdfOptions());
        pdfInstance.saveDataUri(dataUri, fileName, pdfInstance.saveOptions());
      } catch (error) {
        this.toastr.error("There was an error exporting the Complaint PDF.");
      } finally {
        this.isExportingPdf = false;
        this.changeDetectorRef.detectChanges();
      }
    }

    private waitForExportRender(): Promise<void> {
      return new Promise(resolve => requestAnimationFrame(() => resolve()));
    }

    private getComplaintReferralFullName(referral: IComplaintReferral): string {
      return [referral.firstName, referral.lastName].filter(value => !!value).join(' ');
    }

    private getComplaintReferralAgencyDisplay(referral: IComplaintReferral): string {
      if (referral.agencyType && referral.agencyName) {
        return referral.agencyType + ': ' + referral.agencyName;
      }

      return referral.agencyType || referral.agencyName || '';
    }

    private getComplaintOwnerTenantFullName(ownerTenant: IComplaintOwnerTenant): string {
      return [ownerTenant.firstName, ownerTenant.lastName].filter(value => !!value).join(' ');
    }

    private refreshComplaintInspectionDisplayRows(): void {
      const inspectionDetailsColumn = this.complaintInspectionTable.layout.container.find((cellData: any) => cellData.columnName === 'inspectionDetails');

      if (!inspectionDetailsColumn) {
        this.complaintInspectionDisplayRows = [];
        return;
      }

      const displayRows: Array<{
        inspectionDate: string | null;
        inspectionType: string;
        scope: string;
        inspectionDetails: string;
        isContinuation: boolean;
        sourceRow: IComplaintInspection;
      }> = [];

      this.complaintInspections.forEach((row: IComplaintInspection) => {
        const inspectionDetails = this.getInspectionNarrativeText(row, inspectionDetailsColumn);
        const detailChunks = this.splitInspectionDetailsIntoPageRows(inspectionDetails);

        detailChunks.forEach((detailChunk, index) => {
          displayRows.push({
            inspectionDate: index === 0 ? row.inspectionDate : null,
            inspectionType: index === 0 ? this.displayLimit(row.inspectionType, 25) : '',
            scope: index === 0 ? this.displayLimit(row.scope, 25) : '',
            inspectionDetails: detailChunk,
            isContinuation: index > 0,
            sourceRow: row
          });
        });
      });

      this.complaintInspectionDisplayRows = displayRows;
    }

    private splitInspectionDetailsIntoPageRows(inspectionDetails: string): string[] {
      if (!inspectionDetails) {
        return [''];
      }

      if (this.measureInspectionDetailsHeight(inspectionDetails) <= this.inspectionDetailsMaxChunkHeight) {
        return [inspectionDetails];
      }

      const chunks: string[] = [];
      const tokens = inspectionDetails.split(/(\s+)/).filter(token => token.length > 0);
      let currentChunk = '';

      tokens.forEach(token => {
        const candidateChunk = currentChunk + token;

        if (currentChunk && this.measureInspectionDetailsHeight(candidateChunk) > this.inspectionDetailsMaxChunkHeight) {
          chunks.push(currentChunk.trimEnd());
          currentChunk = token.trimStart();

          if (currentChunk && this.measureInspectionDetailsHeight(currentChunk) > this.inspectionDetailsMaxChunkHeight) {
            const forcedChunks = this.forceSplitInspectionDetailsChunk(currentChunk);
            chunks.push(...forcedChunks.slice(0, -1));
            currentChunk = forcedChunks[forcedChunks.length - 1];
          }
        } else {
          currentChunk = candidateChunk;
        }
      });

      if (currentChunk.trim().length > 0) {
        chunks.push(currentChunk.trimEnd());
      }

      return chunks.length ? chunks : [''];
    }

    private forceSplitInspectionDetailsChunk(text: string): string[] {
      const chunks: string[] = [];
      let currentChunk = '';

      for (const character of text) {
        const candidateChunk = currentChunk + character;

        if (currentChunk && this.measureInspectionDetailsHeight(candidateChunk) > this.inspectionDetailsMaxChunkHeight) {
          chunks.push(currentChunk);
          currentChunk = character;
        } else {
          currentChunk = candidateChunk;
        }
      }

      if (currentChunk) {
        chunks.push(currentChunk);
      }

      return chunks;
    }

    private measureInspectionDetailsHeight(text: string): number {
      if (typeof document === 'undefined') {
        return 0;
      }

      const measurementElement = document.createElement('div');
      measurementElement.style.fontFamily = 'Roboto, "Helvetica Neue", sans-serif';
      measurementElement.style.fontSize = '14px';
      measurementElement.style.fontWeight = '400';
      measurementElement.style.left = '-9999px';
      measurementElement.style.lineHeight = '20px';
      measurementElement.style.padding = '0';
      measurementElement.style.position = 'absolute';
      measurementElement.style.top = '0';
      measurementElement.style.visibility = 'hidden';
      measurementElement.style.whiteSpace = 'pre-wrap';
      measurementElement.style.width = `${this.inspectionDetailsMeasurementWidth}px`;
      measurementElement.style.wordBreak = 'break-word';
      measurementElement.style.overflowWrap = 'anywhere';
      measurementElement.textContent = text;

      document.body.appendChild(measurementElement);
      const height = measurementElement.scrollHeight;
      document.body.removeChild(measurementElement);

      return height;
    }

    getComplaintAssociations(){
        this.complaintService.getComplaintAssociations(this.complaintId).subscribe(result=>{        
          this.complaintAssocations = result;
          this.complaintAssociationTable.layout.data = this.complaintAssocations;
          this.complaintAssocationDataSource = new MatTableDataSource(this.complaintAssocations);
        },error=>{      
          this.toastr.error("There was an error getting the Complaint Associations: ", error)
        });
      }
    
      getComplaintReferrals(){
        this.complaintService.getComplaintReferrals(this.complaintId).subscribe(result=>{        
          this.complaintReferrals = result;
          const complaintReferralExportRows = result.map(referral => ({
            ...referral,
            fullName: this.getComplaintReferralFullName(referral),
            agencyTypeName: this.getComplaintReferralAgencyDisplay(referral)
          }));
          this.complaintReferralTable.layout.data = complaintReferralExportRows;
          this.complaintReferralsDataSource = new MatTableDataSource(complaintReferralExportRows);
        },error=>{      
          this.toastr.error("There was an error getting the Complaint Referrals: ", error)
        });
      }
    
    
    
      getComplaintOwnerTenants(){
        this.complaintService.getComplaintOwnerTenants(this.complaintId).subscribe(result=>{        
          this.complaintOwnerTenants = result;
          const complaintOwnerTenantExportRows = result.map(ownerTenant => ({
            ...ownerTenant,
            fullName: this.getComplaintOwnerTenantFullName(ownerTenant)
          }));
          this.complaintOwnerTenantTable.layout.data = complaintOwnerTenantExportRows;
          this.complaintOwnerTenantDataSource = new MatTableDataSource(complaintOwnerTenantExportRows);
        },error=>{
          this.toastr.error("There was an error getting the Complaint Owner Tenants: ", error)
        });
      }
    
      getComplaintJurisdictions(){
        this.complaintService.getComplaintJurisdictions(this.complaintId).subscribe(result=>{        
        
          if(result && result.length > 0){
            this.complaintJurisdictions = result.map((jurisdiction: any)=>jurisdiction.jurisdiction).join(", ");
            
          }
        },error=>{
          this.toastr.error("There was an error getting the Complaint jurisdictions: ", error)
        });
      }
      
      getComplaintEnforcementCategories(){
        this.complaintService.getComplaintEnforcementCategories(this.complaintId).subscribe(result=>{ 
            if(result && result.length > 0){
                this.complaintEnforcementCategory = result.map((category: any)=>category.enforcementCategory).join(", ");
          }
        },error=>{
          this.toastr.error("There was an error getting the Complaint Enforcement Categories: ", error)
        });
      }
      getComplaintActions(){
        this.complaintService.getComplaintActions(this.complaintId).subscribe(result=>{        
          this.complaintActions = result;
          this.complaintActionTable.layout.data = this.complaintActions;
        this.complaintActionDataSource = new MatTableDataSource(this.complaintActions);
        },error=>{
          this.toastr.error("There was an error getting the Complaint Actions: ", error)
        });
      }
    
      getComplaintInspections(){
        this.complaintService.getComplaintInspections(this.complaintId).subscribe(result=>{        
          this.complaintInspections = result;
          this.expandedInspectionNarratives = {};
          this.complaintInspectionTable.layout.data = this.complaintInspections;
          this.complaintInspectionDataSource = new MatTableDataSource(this.complaintInspections);
          this.refreshComplaintInspectionDisplayRows();
        },error=>{
          this.toastr.error("There was an error getting the Complaint Inspections: ", error)
        });
      }
  }
